export enum AccountType {
  private = "private",
  company = "company",
}

export enum RegistrationStepGe {
  ACCOUNTTYPE = "account-type",
  CONTACTINFO = "contact-info",
  PASSWORD = "password",
  ADDITIONALINFO = "additional-info",
}

export enum RegistrationCompanyStepGe {
  ACCOUNTTYPE = "account-type",
  COMPANYINFO = "company-info",
  CONTACTINFO = "contact-info",
  PASSWORD = "password",
}

export enum RegistrationStepUz {
  CONTACTINFO = "contact-info",
  PASSWORD = "password",
  DOCUMENTINFO = "document-info",
  ADDRESSINFO = "address-info",
}

export enum RegistrationStepUk {
  CONTACTINFO = "contact-info",
  PASSWORD = "password",
  ADDITIONALINFO = "additional-info",
  ADDRESSINFO = "address-info",
}
